// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms {
    margin-top: 70px;
}

.interact-vid-sec {
    padding: 40px 110px 0px 110px;
}

.interact-vid-sec.pad {
    padding-bottom: 130px;
    color:#5627d8;
}

ol {
    margin: 0 0 1.5em;
    padding: 0;
    counter-reset: item;
}

ol > li {
    margin: 0;
    padding: 0 0 0 2em;
    text-indent: -2em;
    list-style-type: none;
    counter-increment: item;
}

ol > li:before {
    display: inline-block;
    width: 1.5em;
    padding-right: 0.5em;
    font-weight: bold;
    text-align: right;
    content: counter(item) ".";
}

ul {
    list-style-type: disc;
}

p {
    text-align: justify;
}

@media (max-width: 991px) {
    .interact-vid-sec {
        padding: 30px 30px 0px !important;
    }
    .custom-height,
    .position-relative.pop5 {
        height: auto !important;
        margin-bottom: 30px;
    }
    .card-body {
        padding-bottom: 20px !important;
    }
    .margin-right-0-mobile {
        margin-right: 0px !important;
    }
}

/*WC 04062022*/
.container-fluid h2 {
    text-align: center;
    margin-bottom: 36px;
    /*color: white;
    color:darkmagenta;*/
    color:#5627d8;
    font-size: 35px;
    font-weight: 600;
}
/*WC 04062022*/

.logo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 35px;
}

.logo {
    height: 75px;
    margin: 0 10px;  /* adjust as needed */
}


`, "",{"version":3,"sources":["webpack://./src/app/beforeLogin/security-policy/security-policy.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,iCAAiC;IACrC;IACA;;QAEI,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,+BAA+B;IACnC;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,mBAAmB;IACnB;uBACmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA,cAAc;;AAEd;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc,GAAG,qBAAqB;AAC1C","sourcesContent":[".terms {\n    margin-top: 70px;\n}\n\n.interact-vid-sec {\n    padding: 40px 110px 0px 110px;\n}\n\n.interact-vid-sec.pad {\n    padding-bottom: 130px;\n    color:#5627d8;\n}\n\nol {\n    margin: 0 0 1.5em;\n    padding: 0;\n    counter-reset: item;\n}\n\nol > li {\n    margin: 0;\n    padding: 0 0 0 2em;\n    text-indent: -2em;\n    list-style-type: none;\n    counter-increment: item;\n}\n\nol > li:before {\n    display: inline-block;\n    width: 1.5em;\n    padding-right: 0.5em;\n    font-weight: bold;\n    text-align: right;\n    content: counter(item) \".\";\n}\n\nul {\n    list-style-type: disc;\n}\n\np {\n    text-align: justify;\n}\n\n@media (max-width: 991px) {\n    .interact-vid-sec {\n        padding: 30px 30px 0px !important;\n    }\n    .custom-height,\n    .position-relative.pop5 {\n        height: auto !important;\n        margin-bottom: 30px;\n    }\n    .card-body {\n        padding-bottom: 20px !important;\n    }\n    .margin-right-0-mobile {\n        margin-right: 0px !important;\n    }\n}\n\n/*WC 04062022*/\n.container-fluid h2 {\n    text-align: center;\n    margin-bottom: 36px;\n    /*color: white;\n    color:darkmagenta;*/\n    color:#5627d8;\n    font-size: 35px;\n    font-weight: 600;\n}\n/*WC 04062022*/\n\n.logo-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 35px;\n}\n\n.logo {\n    height: 75px;\n    margin: 0 10px;  /* adjust as needed */\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
